import RoomEquipment from './RoomEquipment';

export default RoomEquipment;
